import { useState, useEffect, useContext } from 'react';
import Raven from 'raven-js';
import { AuthedI18nContext, PublicI18nContext } from '../context/I18nContext';
import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from '../selectors/AuthSelectors';
export const useTranslations = (translations, shouldLoadTranslations = true) => {
  const [isReady, setIsReady] = useState(false);
  const i18nContext = useAppSelector(state => isAppAuthSelector(state) ? AuthedI18nContext : PublicI18nContext);
  const {
    i18nLoader
  } = useContext(i18nContext);
  useEffect(() => {
    if (shouldLoadTranslations && i18nLoader) {
      i18nLoader.register(translations).then(() => {
        setIsReady(true);
      }).catch(error => {
        Raven.captureException(error, {
          fingerprint: ['Failed to register translations']
        });
      });
    }
  }, [i18nLoader, shouldLoadTranslations, translations]);
  return {
    isReady
  };
};